module.exports = __webpack_public_path__ + "img/NOK.22669253.svg";